var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validMarkets.length)?_c('div',{staticClass:"msg-market-container"},[_c('Swiper',{ref:"swiper",class:{
      'multiples-swiper': _vm.validMarkets.length > 1,
      'swiper-no-swiping' : _vm.validMarkets.length <= 1
    },attrs:{"options":{
      slidesPerView: 'auto',
      spaceBetween: 10,
    }}},[_vm._l((_vm.validMarkets),function(market){return [_c('SwiperSlide',{key:_vm.getKey(market)},[_c('MsgMarket',{attrs:{"market-id":Array.isArray(market)? market[0].id : market.id,"market":market,"market-name":_vm.getMarketName(market)},on:{"selectVisible":_vm.onSelectVisible}})],1)]})],2),_vm._v(" "),_c('BottomBarClose')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }